import { render, staticRenderFns } from "./followUpManagement.vue?vue&type=template&id=630cd735&scoped=true"
import script from "./followUpManagement.vue?vue&type=script&lang=js"
export * from "./followUpManagement.vue?vue&type=script&lang=js"
import style0 from "./followUpManagement.vue?vue&type=style&index=0&id=630cd735&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "630cd735",
  null
  
)

export default component.exports